// extracted by mini-css-extract-plugin
export default {"main":"learningZonePage_main__KEC9A","mainLayout":"learningZonePage_mainLayout__n4ahA","right":"learningZonePage_right__Nf5NC","learningZone":"learningZonePage_learningZone__6DFvh"};